<template>
    <div>
        <slot v-if="!isLoaded"></slot>
        <section v-else class="category__banner">
            <span :class="{'category__back-btn--hidden': typeof currentCategory.parent === 'undefined'}">
                <a class="category__back-btn"
                   v-if="typeof currentCategory.parent !== 'undefined'"
                   :href="getCategoryUrl(currentCategory.parent.url)"
                   :title="currentCategory.parent.details[0].metaTitle || currentCategory.parent.details[0].name">
                </a>
            </span>
            <div class="wrapper">
                <div class="category__pretitle">
                    <a v-if="currentCategoryRoot !== ''"
                       :href="getCategoryUrl(currentCategoryRoot.url)"
                       :title="currentCategoryRoot.name">
                        {{ currentCategoryRoot.name }}
                    </a>
                    <div v-else>
                        {{ currentCategoryRoot }}
                    </div>
                </div>
                <h1 class="category__title">
                    {{ currentCategory.details[0].name }}
                </h1>
            </div>

            <div class="category__banner-sub-wrapper"
                 v-if="currentCategoryChildes.length > 0">
                <div class="category__banner-sub-inner">
                    <a v-for="category in currentCategoryChildes"
                       class="category__banner-item"
                       :class="{'category__banner-item--active': category.active}"
                       :href="getCategoryUrl(category.url)"
                       :title="category.metaTitle || category.name">
                        {{ category.name }}
                    </a>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {

        data() {
            return {
                isLoaded: false
            }
        },

        computed: {

            ...mapState({
                currentCategory: state => state.navigation.currentCategory,
                navigationTree: state => state.navigation.tree
            }),

            currentCategoryRoot() {

                if (typeof this.currentCategory.parent === 'undefined') {
                    return ''
                } else {

                    let parent = this.currentCategory.parent;

                    while (typeof parent.parent !== 'undefined') {
                        parent = parent.parent;
                    }

                    return {
                        name: parent.details[0].name,
                        id: parent.id,
                        type: parent.type,
                        url: parent.url
                    }
                }
            },

            currentCategoryChildes() {

                let childes = [];
                let brand = false;

                if (typeof this.currentCategory.parent !== 'undefined' && this.currentCategory.parent.id === 412) {
                    brand = true;
                }

                if (this.currentCategory.children && !brand) {
                    for (let childKey in this.currentCategory.children) {
                        if (
                            this.currentCategory.children.hasOwnProperty(childKey) &&
                            typeof this.currentCategory.children[childKey].details[0] !== 'undefined'
                        ) {
                            childes.push({
                                id: this.currentCategory.children[childKey].id,
                                name: this.currentCategory.children[childKey].details[0].name,
                                type: this.currentCategory.children[childKey].type,
                                active: false,
                                url: this.currentCategory.children[childKey].url,
                                metaTitle: this.currentCategory.children[childKey].details[0].metaTitle
                            });
                        }
                    }
                } else {
                    if (typeof this.currentCategory.parent !== 'undefined') {
                        for (let childKey in this.currentCategory.parent.children) {
                            if (
                                this.currentCategory.parent.children.hasOwnProperty(childKey) &&
                                typeof this.currentCategory.parent.children[childKey].details[0] !== 'undefined'
                            ) {
                                childes.push({
                                    id: this.currentCategory.parent.children[childKey].id,
                                    name: this.currentCategory.parent.children[childKey].details[0].name,
                                    type: this.currentCategory.parent.children[childKey].type,
                                    active: this.currentCategory.parent.children[childKey].id === this.currentCategory.id,
                                    url: this.currentCategory.parent.children[childKey].url,
                                    metaTitle: this.currentCategory.parent.children[childKey].details[0].metaTitle
                                });
                            }
                        }
                    }
                }

                return childes;
            },
        },
        created() {

            $('document').ready(function () {

                setTimeout(function () {

                    $('.basket__loader').hide();
                    $('.js--category__outer').show();

                }, 500);

            });

            if (this.navigationTree.length <= 0) {
                this.$store.dispatch('loadPartialNavigationTree', this.currentCategory.id)
                    .then(response => {
                        this.$store.commit('setNavigationTree', response);
                        this.$store.dispatch('setCurrentCategoryById', {
                            categoryId: parseInt(this.currentCategory.id),
                        });
                        this.$nextTick(() => {
                            this.isLoaded = true;
                        });
                    })
            }else {
                this.isLoaded = true;
            }
        },
        methods: {
            getCategoryUrl(url) {
                const trailingSlash = url[0] === '/' ? '' : '/';
                const prefix = App.urls.includeLanguage ? `/${ App.language }${ trailingSlash }` : '';

                return prefix + url;
            }
        }
    }
</script>
